import { PrivacyScreen } from "@/components/legalPolicies";
import MainLayout from "@/layouts/MainLayout";

const Privacy = () => {
  return (
    <MainLayout
      bgTheme="var(--background-light)"
      navbarTheme="light"
      title="Privacy Policy"
      description="Privacy is a page where the client can read the legal information about the product/services"
    >
      <PrivacyScreen />
    </MainLayout>
  );
};
export default Privacy;
